module.exports = __webpack_public_path__ + "img/jianjietopmin.2db89120.jpg";